import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../node_modules/@placekit/uikit/src/styles/fonts/fira-code-symbols2-wght-normal.woff2%22,%22weight%22:%22300%20700%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22unicode-range%22,%22value%22:%22U+2000-2001,%20U+2004-2008,%20U+200A,%20U+23B8-23BD,%20U+2500-259F%22}]}],%22variableName%22:%22firaCodeSymbols2%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'firaCodeSymbols2'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
